import React from 'react';
import ReactDOM from 'react-dom';
import store from 'store';
import moment from 'moment';
import Handlebars from 'handlebars';

import VideoCall from './VideoCall';
import defaultPicture from '../images/contact-default.png';

import waitingMp3 from '../sounds/waiting.mp3';
import ringingMp3 from '../sounds/ringing.mp3';

const waitingAudio = new Audio(waitingMp3);
waitingAudio.loop = true;

const ringingAudio = new Audio(ringingMp3);
ringingAudio.loop = true;

export default class IncomingCall extends React.Component {
  constructor(props) {
    super(props);
    this.defaultPicture = defaultPicture;
    this.rejectCall = this.rejectCall.bind(this);
    this.acceptCall = this.acceptCall.bind(this);
  }

  async componentDidMount() {
    const locale = global.dictionaries.calling;
    this.audio = window.VideoCall ? waitingAudio : ringingAudio;
    this.audio.currentTime = 0;
    this.audio.play();
    this.timeoutId = setTimeout(() => {
      ReactDOM.unmountComponentAtNode(document.getElementById('incomingCall'));
      this.props.socket.emit('call-timeout', { email: this.props.email });
      window.Notifications.add({
        datetime: new Date(),
        expires: moment().add(1, 'day').toDate(),
        icon: 'fa fa-phone',
        title: locale.missedCallTitle,
        content: Handlebars.compile(locale.missedCallNotAvailable)({ personName: this.props.name })
      });
    }, 90 * 1000);
  }

  componentWillUnmount() {
    if (this.audio) this.audio.pause();
    clearTimeout(this.timeoutId);
  }

  getTerminationNotice() {
    const locale = global.dictionaries.calling;

    if (window.VideoCall) {
      return (<p className="notice">{locale.existingCallWarning}</p>);
    }
    return '';
  }

  rejectCall() {
    this.props.socket.emit('reject-call', { email: this.props.email });
    ReactDOM.unmountComponentAtNode(document.getElementById('incomingCall'));
  }

  acceptCall() {
    if (window.VideoCall) {
      window.VideoCall.hangup();
    }
    this.props.socket.emit('accept-call', { email: this.props.email });
    ReactDOM.unmountComponentAtNode(document.getElementById('incomingCall'));
    ReactDOM.render(
      <VideoCall
        socket={this.props.socket}
        senderEmail={this.props.email}
        receiverEmail={store.get('credentials').key}
        remoteUserName={this.props.name}
        remoteUserEmail={this.props.email}
      />,
      document.getElementById('videoCall'));
  }

  render() {
    const locale = global.dictionaries.calling;

    return (
      <div className={`modal is-active ${window.VideoCall ? 'existing-call' : ''}`}>
        <div className="modal-background" />
        <div className="modal-content">
          <div className="contact-card">
            <img
              src={this.props.picture || this.defaultPicture}
              className="image"
              alt={this.props.name}
            />
            <p className="name">{this.props.name}</p>
            <hr />
            <p className="call-button">
              <span className="icon">
                <i className="fa fa-circle-o-notch fa-spin" />
              </span>
              &nbsp;
              <span style={{ textTransform: 'capitalize' }}>{locale.incoming} ...</span>
            </p>
            {this.getTerminationNotice()}
            <p className="accept-button" onClick={this.acceptCall}>
              <span className="icon">
                <i className="fa fa-video-camera" />
              </span>
              &nbsp;
              <span style={{ textTransform: 'capitalize' }}>{locale.accept}</span>
            </p>
            <p className="reject-button" onClick={this.rejectCall}>
              <span className="icon">
                <i className="fa fa-times" />
              </span>
              &nbsp;
              <span style={{ textTransform: 'capitalize' }}>{locale.reject}</span>
            </p>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/IncomingCall.js